<template>
    <div class="terms-wrapper">
        <app-header-mini v-if="this.$route.params.page === 'catalogues'" :img="'/static/img/download_center/catalogues/header.jpg'" :texts="texts"></app-header-mini>
        <app-header-mini v-if="this.$route.params.page === 'certificates'" :img="'/static/img/download_center/certificates/header.jpg'" :texts="texts"></app-header-mini>
        <!-- <app-header-mini v-if="this.$route.params.page === 'reports'" :img="'/static/img/download_center/reports/header.jpg'" :texts="texts"></app-header-mini> -->
        <app-header-mini v-if="this.$route.params.page === 'presentations'" :img="'/static/img/download_center/presentations/header.jpg'" :texts="texts"></app-header-mini>
        <app-header-mini v-if="this.$route.params.page === 'generalterms'" :img="'/static/img/download_center/presentations/header.jpg'" :texts="texts"></app-header-mini>
    </div>
</template>

<script>
import HeaderMini from "../shared/HeaderMini";
export default {
  components: {
    appHeaderMini: HeaderMini
  },
  data() {
      return {
          texts: ['Download Center']
      }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/download-center/Header.vue